import { resources as LearningActivity } from "../components/LearningActivity";
import { resources as Users } from "../components/Users";
import { resources as AcademicRequests } from "components/AcademicRequests";
import { resources as StaffRequests } from "components/StaffRequests";
import { resources as Educations } from "../components/Educations";
import { resources as AcademicYears } from "../components/AcademicYears";
import { resources as Administration } from "../components/Administration";
import { resources as Leaves } from "../components/Leaves";
import { resources as Notifications } from "components/Notifications";
import { resources as CashFlow } from "../components/CashFlow";
import { resources as Campaigns, campaignResources } from "../components/Campaigns";
import { resources as Candidates, candidateResources } from "../components/Candidates";
import { resources as Enrolling } from "../components/EnrollingStudents";
import { resources as CandidatesSettings } from "components/CandidatesSettings";
import { resources as Reports } from "../components/Reports";
import { resources as NacidFlows } from "components/Nacid/NacidFlows";
import { resources as Security } from "../components/Security";
import { resources as Scholarships } from "../components/Scholarships";
import { resources as Graduation } from "../components/Graduation";
import { resources as AdminPanel } from "../components/AdminPanel";
import { resources as Dormitory } from "../components/Dormitory";
import { resources as Publications } from "../components/Publications";

import { resources as StudyDepartmentInfo } from "../components/Administration/StructuralUnits/StudyDepartmentInfo";
import { resources as CampaignRankings } from "../components/Campaigns/Rankings";
import { resources as GroupBlacklistCountries } from "../components/Administration/StructuralUnits/GroupBlacklistCountries";
import { resources as WeeklyScheduleDisciplines } from "../components/LearningActivity/CreateWeeklySchedule/WeeklyScheduleDisciplines";
import { resources as WeeklyScheduleEdit } from "../components/LearningActivity/CreateWeeklySchedule/Edit";
import { resources as StreamsWeeklyScheduleEdit } from "../components/LearningActivity/StreamsWeeklySchedule/Edit";
import { resources as ManageStudentsPresence } from "../components/LearningActivity/Classes/ManageAttendance";
import { resources as ManageEquipment } from "../components/LearningActivity/Classes/ManageEquipment";
import { resources as UsersInfo } from "../components/Users/Info";
import { resources as DeclarationsAddDocuments } from "../components/CandidatesSettings/Declarations/AddDocuments";
import { resources as CandidateStates } from "../components/Candidates/CandidateStates";
import { resources as CyclicExamExceptions } from "../components/Educations/Curriculum/CyclicExamExceptions";
import { resources as CareerCenter } from "../components/CareerCenter";
import { resources as Alumni } from "../components/Alumni";
import { resources as Erasmus } from "../components/Erasmus";
import { resources as Specialists } from "../components/Specialists";
import { resources as Doctoral } from "../components/Doctoral";
import { resources as DoctoralCampaignRankings } from "../components/Doctoral/DoctoralCampaignRankings";
import { resources as StudentRecords } from "../components/Users/Students/Show/StudentRecords";
import { resources as PartialRecord } from "../components/Users/Students/Show/StudentRecords/PartialRecord";
import { resources as Topics } from "../components/Educations/Curriculum/Topics";
import { resources as CreateTopics } from "../components/Educations/Curriculum/Topics/CreateTopics";
import { resources as EditTopics } from "../components/Educations/Curriculum/Topics/EditTopics";
import { resources as DetailsStaffRequest } from "../components/StaffRequests/DetailsStaffRequest";
import { resources as EditInternshipPlans } from "../components/Graduation/InternshipPlans/EditInternshipPlans";
import { resources as EditBusinessTrips } from "../components/Leaves/BusinessTrip/EditBusinessTrips";
import { resources as EditSickLeaves } from "../components/Leaves/SickLeaves/Edit";
import { resources as EditVacations } from "../components/Leaves/Vacations/EditVacations";
import { resources as CorrectVacations } from "../components/Leaves/Vacations/CorrectVacations";

import { resources as IndividualCurriculum } from "../components/Users/Students/IndividualCurriculum";
import { resources as AttestationsManagement } from "../components/Users/Students/AttestationsManagement";
import { resources as UpdateStudents } from "../components/Graduation/ScheduleIndividualSlot/UpdateStudents";
import { resources as CreateGroupStateExam } from "../components/Graduation/InternshipStateExams/CreateGroupStateExam";
import { resources as CreateSingleStateExam } from "../components/Graduation/InternshipStateExams/CreateSingleStateExam";
import { resources as AddGroupStateExam } from "../components/Graduation/InternshipStateExams/AddGroupStateExam";
import { resources as MonthlyInternshipAttestations } from "../components/Graduation/InternshipStudents/MonthlyInternshipAttestations";
import { resources as CreateMonthlyInternshipAttestations } from "../components/Graduation/InternshipStudents/CreateMonthlyInternshipAttestation";
import { resources as StateExamsResults } from "../components/Graduation/InternshipStateExams/StateExamsResults";
import { resources as AddStateExamsResults } from "../components/Graduation/InternshipStateExams/AddStateExamsResults";
import { resources as HealthcareCourseDailyPrices } from "../components/Specialists/HealthcareCourses/HealthcareCourseDailyPrices";
import { resources as HealthcareCourseFeeDistributions } from "../components/Specialists/HealthcareCourses/HealthcareCourseFeeDistributions";
import { resources as CurrriculumModules } from "../components/Educations/Curriculum/CurriculumModules";
import { resources as CreateCurriculumModule } from "../components/Educations/Curriculum/CurriculumModules/CreateModule";
import { resources as EditCurriculumModule } from "../components/Educations/Curriculum/CurriculumModules/EditModule";
import { resources as ShowCurriculumModule } from "../components/Educations/Curriculum/CurriculumModules/ShowModule";

const resources = [
  //menu resources
  LearningActivity,
  Users,
  AcademicRequests,
  StaffRequests,
  Educations,
  AcademicYears,
  Administration,
  Leaves,
  Notifications,
  CashFlow,
  Campaigns,
  Candidates,
  Enrolling,
  CandidatesSettings,
  Reports,
  Security,
  Scholarships,
  Graduation,
  Specialists,
  Doctoral,
  DoctoralCampaignRankings,
  Dormitory,
  Publications,
  // Nomenclature,
  // Employees,

  //other resources
  ...campaignResources,
  ...candidateResources,
  StudyDepartmentInfo,
  CampaignRankings,
  GroupBlacklistCountries,
  WeeklyScheduleDisciplines,
  WeeklyScheduleEdit,
  StreamsWeeklyScheduleEdit,
  ManageStudentsPresence,
  ManageEquipment,
  UsersInfo,
  DeclarationsAddDocuments,
  CandidateStates,
  CyclicExamExceptions,
  CareerCenter,
  Alumni,
  Erasmus,
  StudentRecords,
  PartialRecord,
  Topics,
  CreateTopics,
  EditTopics,
  DetailsStaffRequest,
  EditInternshipPlans,
  EditBusinessTrips,
  EditSickLeaves,
  EditVacations,
  CorrectVacations,
  IndividualCurriculum,
  AttestationsManagement,
  UpdateStudents,
  CreateGroupStateExam,
  CreateSingleStateExam,
  AddGroupStateExam,
  MonthlyInternshipAttestations,
  CreateMonthlyInternshipAttestations,
  StateExamsResults,
  AddStateExamsResults,
  HealthcareCourseDailyPrices,
  HealthcareCourseFeeDistributions,
  CurrriculumModules,
  CreateCurriculumModule,
  EditCurriculumModule,
  ShowCurriculumModule,
  NacidFlows,
  AdminPanel,
];

export { resources };

// Системата трябва да позволява създаването, прегледа и редакцията на следните информационни единици:
// •	Кандидат-студенти;
// •	Студенти;
// •	Специализанти;
// •	Докторанти;
// •	Служители на университета;
// •	Структурни единици (факултети, катедри и др.);
// •	Специалности;
// •	Сгради;
// •	Зали;
// •	Декларации.
